import { render, staticRenderFns } from "./CommercialPrintActionsBell.vue?vue&type=template&id=5d12e414"
import script from "./CommercialPrintActionsBell.vue?vue&type=script&lang=js"
export * from "./CommercialPrintActionsBell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports